//When dom is ready
document.addEventListener("DOMContentLoaded", function () {
  var subheader = document.getElementsByClassName("sticky-subheader")[0];
  var subheaderSticky = subheader ? subheader.dataset.sticky : false;
  var collection_toolbar = document.querySelector(".collection__toolbar");
  //Detect when user scroll down
  document.addEventListener("scroll", function () {
    var scroll = document.documentElement.scrollTop;
    if (scroll < 250 && scroll > 100) {
      if (!subheaderSticky) {
        document
          .getElementsByClassName("header")[0]
          .classList.add("initial-navbar-scroll");
        document.querySelector(".header--filler").style.height = " 64px";
      }
      if (subheader != undefined) {
        subheader.classList.add("initial-subheader-scroll");
      }
    } else if (scroll > 250) {
      if (!subheaderSticky) {
        document
          .getElementsByClassName("header")[0]
          .classList.add("navbar-scroll");
      }
      if (subheader != undefined) {
        document.querySelector(".subheader--filler").style.height =
          subheader.offsetHeight + "px";
        subheader.classList.add("subheader-scroll");
        subheader.classList.add("show");
      }

      var menu = document.getElementsByClassName("nav-bar__item");
      if (menu.length > 0) {
        for (var i = 0; i < menu.length; i++) {
          menu[i].classList.remove("is-dropdown-open");
          if (menu[i].getElementsByClassName("mega-menu")[0] != undefined) {
            menu[i]
              .getElementsByClassName("mega-menu")[0]
              .setAttribute("aria-hidden", "true");
          }
          if (menu[i].getElementsByClassName("nav-bar__link")[0] != undefined) {
            menu[i]
              .getElementsByClassName("nav-bar__link")[0]
              .setAttribute("aria-expanded", "false");
          }
        }
      }
    } else {
      if (!subheaderSticky) {
        document
          .getElementsByClassName("header")[0]
          .classList.remove("navbar-scroll");
        document
          .getElementsByClassName("header")[0]
          .classList.remove("initial-navbar-scroll");
      }
      collection_toolbar && collection_toolbar.classList.remove("stick-header");
      if (subheader != undefined) {
        subheader.classList.remove("subheader-scroll");
        subheader.classList.remove("initial-subheader-scroll");
        document.querySelector(".subheader--filler").style.height = "auto";
      }
      document.querySelector(".header--filler").style.height = " auto";
    }
  });

  // Detect when user scroll up without reach top
  var lastScrollTop = 0;
  window.addEventListener(
    "scroll",
    function () {
      var st = window.pageYOffset || document.documentElement.scrollTop;

      var header = document.getElementsByClassName("header")[0];

      if (st > lastScrollTop) {
        header.classList.remove("show");
        collection_toolbar &&
          collection_toolbar.classList.remove("stick-header");
        // if (subheader != undefined) {
        //   subheader.classList.remove("show");
        // }
      } else {
        document.getElementsByClassName("header")[0].classList.add("show");
        if (header.classList.contains("navbar-scroll")) {
          collection_toolbar &&
            collection_toolbar.classList.add("stick-header");
        }
        // if (subheader != undefined) {
        //   subheader.classList.add("show");S
        // }
      }
      lastScrollTop = st <= 0 ? 0 : st;
    },
    false
  );


  
});
